import React, { useEffect, useState } from "react";
import "./ProductColor.css";
import { Button, Switch } from "antd";
import { fabric } from "fabric";
import { SketchPicker } from "react-color";
import ImagePaletteComponent from "./ImagePaletteComponent";
import ImagePaletteBox from "./ImagePaletteBox";
import axios from "axios";
import bringtofront from '../assets/bringtofront.png';

import mirrorvertical from '../assets/vertical.png';

import mirrorhorizontal from '../assets/horizontal.png';
import lock from '../assets/lock.png';
import unlock from '../assets/unlock.png';
import objectcenter from '../assets/objectcenter.png';
import close from "../assets/close.png"
import colorclip from "../assets/colormobicon.svg"
import transformclip from "../assets/transformclip.svg"
import rotationmobtext from "../assets/rotationmobtext.svg"
import backgroundColor from "../assets/background-color.svg"



export default function DetailImageBox({
  imgwidth,
  imgheight,
  initialPaletteColors,
  canvas,
  isPng,
  setIsPng,
  addToHistory,
  saveCanvasDataToLocalStorage,
  activeTab,
  calculatePrice,
  closePropertiesSidebar,
  showColorPalette,
  setShowColorPalette,
  
}) {
  const [isLocked, setIsLocked] = useState(false);
  const [rotation, setRotation] = useState(0); // New state for rotation

  const [removeBackground, setRemoveBackground] = useState(false);
  const [color, setColor] = useState("#000000");
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [colorPicker, setColorPicker] = useState(false);
  const [originalImageUrl, setOriginalImageUrl] = useState(null); // Store original image URL
  const [dominantColorCode, setDominantColorCode] = useState([]);
  const [dominantColor, setDominantColor] = useState([]);
  const [singleColorMode, setSingleColorMode] = useState(false);
  const [makeColorMode, setMakeColorMode] = useState(false);
  const [singleColor, setSingleColor] = useState({ r: 0, g: 0, b: 0 });
  const [makeColor, setMakeColor] = useState({ r: 0, g: 0, b: 0 });
  const [paletteColors, setPaletteColors] = useState(initialPaletteColors);
  const [showImagePalette, setShowImagePalette] = useState(false); // New state for palette colors
  const activeObject = canvas.getActiveObject();
    const isMobileScreen = window.innerWidth <= 900; // To detect mobile screen
  const [activeTabIndex, setActiveTabIndex] = useState(null); // Manage active tab for mobile screens
  const [isSelected, setIsSelected] = useState(false);
  const [isFlippedHorizontal, setIsFlippedHorizontal] = useState(false); // State for flip horizontal
  const [isFlippedVertical, setIsFlippedVertical] = useState(false); // St
  const [isCentered, setIsCentered] = useState(false);

  console.log(singleColor);
  const fullcolor = "full color";

  const captureFullState = (obj) => {
  return obj.toObject([
    'id',
            'topPercent',
             'originKey',
             'originalPalette',
             'originalImagePath',
              'colorMap',
            'imageFile',
            'rotation',
            'leftPercent',
            'widthPercent',
            'heightPercent',
            'pathOffset',
            'scaleX',
            'scaleY',
            'zoomY',
            'zoomX',
            'type',
            'left',
            'top',
            'width',
            'height',
            'designElement',
            'ownMatrixCache',
            'aCoords',
            'path',
            'fromWorkingArea',
            'scaleX',
            'scaleY',
            'zIndex',
            'angle',
            'fill',
            'stroke',
            'element',
            'selectable',
            'cacheTranslationX',
            'cacheTranslationY',
            'designElement',
            'oCoords',
            'selectable',
            'strokeWidth',
            'text',
            'fontSize',
            'fontWeight',
            'fontFamily',
            'textAlign',
            'fontStyle',
            'lineHeight',
            'letterSpacing',
            'underline',
            'overline',
            'linethrough',
            'clipPath',
            'clipartPath',
            'opacity',
            'isAddedText',
            'designElement',
            'isAddedClipart',
            'warpType',
            'bend',
            'distortH',
            'dominantColor',
            "dominant_color",
            'distortV',
            'originalPath',
            'fontPath',
            'fontFamily',
            'originalText',
            'color',
            'mode',
            'alpha',
            'bgremove',
            'singleColor',
            'singleColorMode',
            'makeOneColor',
            'makeColor',
            'makeColorMode',
            'paletteColors',
            'bgRemove',
            'bringToFront',
            'center',
            'isSelected',
            'isCentered',
            'session_id',
            'isFullColor',
   
  ]);
};


  useEffect(() => {
    const activeObject = canvas.getActiveObject();
    console.log('active single color',activeObject.makeColorMode);

    
  
      setRemoveBackground(activeObject.bgRemove || false );
      setMakeColorMode(activeObject.makeColorMode || false);
      setSingleColorMode(activeObject.singleColorMode || false);
      setMakeColor(activeObject.makeColor || { r: 0, g: 0, b: 0 });
      setSingleColor(activeObject.singleColor || { r: 0, g: 0, b: 0 });
      setIsFlippedHorizontal(activeObject.flipX || false);
      setIsFlippedVertical(activeObject.flipY || false);
      setIsCentered(activeObject.isCentered || false); 
      setIsSelected(activeObject.isSelected || false); 
      setRotation(activeObject.angle || 0);
      setDominantColorCode(activeObject.dominant_color || null);
      
      // if (activeObject.paletteColors === null) {
      //   activeObject.set('paletteColors', fullcolor);
      // }
  
    console.log('active single color', activeObject.singleColorMode);
    console.log('active Object', activeObject);
  }, [canvas, canvas.getActiveObject()]);

console.log("SingleColorMode", singleColorMode);
console.log("MakeColorMode", makeColorMode);
  
  console.log('dominant color', dominantColorCode);
  const handleCenterObject = () => {
    const canvas = window._canvas;
    const selectedObject = canvas ? canvas.getActiveObject() : null;
    if (selectedObject) {
      selectedObject.center();
      selectedObject.setCoords();
      canvas.renderAll();
  
      // Save the center state in the object
      selectedObject.isCentered = true; // Manually store the centered state
    }
  
    // Toggle the selected state for center button
    setIsCentered(!isCentered);
  };



  useEffect(() => {
  const updateDominantColor = async () => {
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "image") {
      try {
        const imgSrc = activeObject.getSrc();
        const dominantColorArray = await loadImage(imgSrc);

        // Update state and active object property
        setDominantColor(dominantColorArray);
        activeObject.set({ dominant_color: dominantColorArray });

        // Ensure canvas updates after changes
        canvas.renderAll();
      } catch (error) {
        console.error("Error updating dominant color:", error);
      }
    }
  };

  updateDominantColor();
}, [singleColorMode, makeColorMode, removeBackground]); // Runs when color modes or background removal changes

  
  const handleBringToFront = () => {
    const canvas = window._canvas;
    const selectedObject = canvas ? canvas.getActiveObject() : null;
    if (selectedObject) {
      selectedObject.bringToFront();
      canvas.renderAll();
  
      // Save the bring-to-front state in the object
      selectedObject.isSelected = true; // Manually store the bring-to-front state
    }
  
    setIsSelected(!isSelected); // Toggle the state
  };
  

 const handleFlipHorizontal = () => {
    const canvas = window._canvas;
    const selectedObject = canvas ? canvas.getActiveObject() : null;
    if (selectedObject) {
      selectedObject.toggle('flipX');
      canvas.renderAll();
    }

    // Toggle the selected state for flip horizontal
    setIsFlippedHorizontal(!isFlippedHorizontal); 
  };

  const handleFlipVertical = () => {
    const canvas = window._canvas;
    const selectedObject = canvas ? canvas.getActiveObject() : null;
    if (selectedObject) {
      selectedObject.toggle('flipY');
      canvas.renderAll();
    }

    // Toggle the selected state for flip vertical
    setIsFlippedVertical(!isFlippedVertical); 
  };

const handleRotationChange = (value) => {
  const canvas = window._canvas;
  const activeObject = canvas.getActiveObject();

  if (activeObject) {
    const prevState = captureFullState(activeObject); // 🔹 Capture state before rotation

    const center = activeObject.getCenterPoint(); // Save center position before rotating

    activeObject.set({
      centeredRotation: true,
      angle: parseFloat(value), // Ensure value is numeric
    });

    activeObject.setPositionByOrigin(center, "center", "center");
    activeObject.setCoords();

    canvas.renderAll();
    setRotation(value);

    const newState = captureFullState(activeObject); // 🔹 Capture state after rotation
    addToHistory(activeObject, prevState, newState, "rotationChange"); // ✅ Add rotation to history
    saveCanvasDataToLocalStorage(activeTab);
  }
};

  
  

  const handleToggleLock = () => {
    const canvas = window._canvas;
    const activeObject = canvas.getActiveObject();
    if (activeObject) {
      activeObject.set({
        lockMovementX: !isLocked,
        lockMovementY: !isLocked,
        lockScalingX: !isLocked,
        lockScalingY: !isLocked,
        lockRotation: !isLocked,
        lockUniScaling: !isLocked,
      });
      setIsLocked(!isLocked);
      canvas.renderAll();
    }
  };

 
  

  const handleColorChange = (color) => {
    const canvas = window._canvas;
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "image") {
      const blendColorFilter = new fabric.Image.filters.BlendColor({
        color: color.hex,
        mode: "tint",
        alpha: 0.5,
      });
      activeObject.filters = [blendColorFilter];
      activeObject.applyFilters();
      canvas.renderAll();
    }
  };

  function loadImageFromUrl(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
  
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var data = imageData.data;
        var colorMap = {};
        var maxCount = 0;
        var dominantColor = [0, 0, 0];
  
        for (var i = 0; i < data.length; i += 4) {
          var color = [data[i], data[i + 1], data[i + 2]];
          var key = color.join(",");
          colorMap[key] = (colorMap[key] || 0) + 1;
          if (colorMap[key] > maxCount) {
            maxCount = colorMap[key];
            dominantColor = color;
          }
        }
        var rgb = "rgb(" + dominantColor.join(",") + ")";
        resolve(rgb);
      };
      img.onerror = function (error) {
        reject(error);
      };
      img.src = url;
    });
  }


  function loadImage(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
  
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var data = imageData.data;
        var colorMap = {};
        var maxCount = 0;
        var dominantColor = [0, 0, 0];
  
        for (var i = 0; i < data.length; i += 4) {
          var color = [data[i], data[i + 1], data[i + 2]];
          var key = color.join(",");
          colorMap[key] = (colorMap[key] || 0) + 1;
          if (colorMap[key] > maxCount) {
            maxCount = colorMap[key];
            dominantColor = color;
          }
        }
        // Resolve with the array directly
        resolve(dominantColor);
      };
      img.onerror = function (error) {
        reject(error);
      };
      img.src = url;
    });
  }
  
const removeBgColor = async (value) => {
  try {
    const activeObject = canvas.getActiveObject();

    if (activeObject && activeObject.type === "image") {
      const prevState = captureFullState(activeObject); // 🔹 capture before change

      if (value) {
        const imgSrc = activeObject.getSrc();
        const dominantColor = await loadImageFromUrl(imgSrc);
        const dominantColorArray = await loadImage(imgSrc);
        setDominantColorCode(dominantColor);
        setDominantColor(dominantColorArray);

        const removeColorFilter = new fabric.Image.filters.RemoveColor({
          distance: 0.2,
          color: dominantColor,
          alpha: 1,
        });

        activeObject.filters.push(removeColorFilter);
        activeObject.set({
          dominant_color: dominantColorArray,
          bgRemove: true,
        });
      } else {
        const filters = activeObject.filters;
        if (filters && filters.length > 0) {
          for (let i = filters.length - 1; i >= 0; i--) {
            if (filters[i] instanceof fabric.Image.filters.RemoveColor) {
              filters.splice(i, 1);
            }
          }
        }
        activeObject.set({
          dominant_color: null,
          bgRemove: false,
        });
      }

      activeObject.applyFilters();
      canvas.renderAll();

      const newState = captureFullState(activeObject); // 🔹 capture after change
      addToHistory(activeObject, prevState, newState, "modify"); // ✅ push to history
      saveCanvasDataToLocalStorage(activeTab);
    }
  } catch (error) {
    console.error("Error in removeBgColor:", error);
  }
};


  console.log("dominantColorArray",dominantColor);

  const handleSwitchChange = async (checked) => {
    setRemoveBackground(checked);
    const canvas = window._canvas;
    const activeObject = canvas.getActiveObject();
    if (activeObject && activeObject.type === "image") {
      await removeBgColor(checked);
      activeObject.set("bgRemove", checked);
      activeObject.setCoords();
      canvas.renderAll();
    }
  };
  console.log("removeBackground",removeBackground);
const applySingleColor = async (checked) => {
  setSingleColorMode(checked);
  const canvas = window._canvas;
  const activeObject = canvas.getActiveObject();

  if (activeObject && activeObject.type === "image") {
    const prevState = captureFullState(activeObject); // ✅ correct capture

    activeObject.set({ singleColorMode: checked });

    // Remove existing filters
    activeObject.filters = activeObject.filters.filter(
      (filter) => filter.type !== "BlendColor" && filter.type !== "Grayscale"
    );

    if (checked) {
      setColor("#000000");
      setSingleColor({ r: 0, g: 0, b: 0 });

      const blendColorFilter = new fabric.Image.filters.BlendColor({
        color: "#000000",
        mode: "add",
        alpha: 1,
      });

      activeObject.filters.push(new fabric.Image.filters.Grayscale());
      activeObject.filters.push(blendColorFilter);

      activeObject.set("singleColor", {
        r: 0,
        g: 0,
        b: 0,
        a: 1,
      });
    }

    activeObject.applyFilters();
    canvas.renderAll();
    calculatePrice(canvas);
    saveCanvasDataToLocalStorage(activeTab);

    const newState = captureFullState(activeObject); // ✅ correct capture
    addToHistory(activeObject, prevState, newState, 'modify'); // ✅ recorded
  }
};




  
  
  
const applyMakeColor = async (checked) => {
  setMakeColorMode(checked);
  const canvas = window._canvas;
  const activeObject = canvas.getActiveObject();

  if (activeObject && activeObject.type === "image") {
    const prevState = captureFullState(activeObject); // ✅ capture before changes

    // Remove existing BlendColor filters (mode: 'tint')
    activeObject.filters = activeObject.filters.filter(
      (filter) => !(filter instanceof fabric.Image.filters.BlendColor)
    );

    if (checked) {
      setColor("#000000");
      setMakeColor({ r: 0, g: 0, b: 0 });

      const makeColorFilter = new fabric.Image.filters.BlendColor({
        color: "rgb(0,0,0)",
        mode: "tint",
        alpha: 1,
      });

      activeObject.filters.push(makeColorFilter);

      activeObject.set({
        makeColorMode: true,
        makeColor: { r: 0, g: 0, b: 0, a: 1 },
      });
    } else {
      // Remove makeColor flags
      activeObject.set({
        makeColorMode: false,
        makeColor: { r: 0, g: 0, b: 0, a: 1 },
      });
    }

    // Reapply background removal if active
    if (removeBackground) {
      await removeBgColor(true); // assumes this internally calls applyFilters()
    } else {
      activeObject.applyFilters();
    }

    canvas.renderAll();
    calculatePrice(canvas);
    saveCanvasDataToLocalStorage(activeTab);

    const newState = captureFullState(activeObject); // ✅ capture after changes
    addToHistory(activeObject, prevState, newState, "modify"); // ✅ push to history
  }
};


  const rgbToHex = (color) => {
    const toHex = (value) => {
      const hex = value.toString(16);
      return hex.length === 1 ? "0" + hex : hex;
    };
    return `#${toHex(color.r)}${toHex(color.g)}${toHex(color.b)}`;
  };
  
  
  const handleChange = async (color) => {
    const hexColor = rgbToHex(color);
    setColor(hexColor);
    setSingleColor(color.rgb);
    const canvas = window._canvas;
    const activeObject = canvas.getActiveObject();
  
    if (singleColorMode) {
      const existingBlendColorFilter = activeObject.filters.find(
        (filter) => filter instanceof fabric.Image.filters.BlendColor
      );
      const existingGrayscaleFilter = activeObject.filters.find(
        (filter) => filter instanceof fabric.Image.filters.Grayscale
      );

      if (existingBlendColorFilter) {
        activeObject.filters.splice(
          activeObject.filters.indexOf(existingBlendColorFilter),
          1
        );
      }
      if (existingGrayscaleFilter) {
        activeObject.filters.splice(
          activeObject.filters.indexOf(existingGrayscaleFilter),
          1
        );
      }
  
      if (activeObject && activeObject.type === "image") {
        const blendColorFilter = new fabric.Image.filters.BlendColor({
          color: hexColor,
          mode: "add",
          alpha: 1,
        });
  
        activeObject.filters.push(new fabric.Image.filters.Grayscale());
        activeObject.filters.push(blendColorFilter);
        activeObject.applyFilters();
        activeObject.set("singleColor", color);
  
        if (removeBackground) {
          await removeBgColor(true);
        } else {
          canvas.renderAll();
        }
      }
    }
  };
  
  const colorChange = async (color) => {
    const canvas = window._canvas;
    const activeObject = canvas.getActiveObject();
  
    if (activeObject && activeObject.type === "image") {
      const rgbColor = `rgb(${color.r},${color.g},${color.b})`;
      setColor(color.hex);
      setMakeColor(color.rgb);
  
      if (makeColorMode) {
        const existingFilter = activeObject.filters.find(
          (filter) => filter instanceof fabric.Image.filters.BlendColor
        );
        if (existingFilter) {
          activeObject.filters.splice(
            activeObject.filters.indexOf(existingFilter),
            0
          );
        }
  
        activeObject.filters.push(
          new fabric.Image.filters.BlendColor({
            color: rgbColor,
            mode: "tint",
            alpha: 1,
          })
        );
  
        activeObject.applyFilters();
        activeObject.set("makeColorMode", true);
        activeObject.set("makeColor", color);
        if (removeBackground) {
          await removeBgColor(true);
        } else {
          canvas.renderAll();
        }
      }
    }
  };
  
  
  const apiUrl1 = "http://127.0.0.1:5000/api/reset-to-original";
  const handleColorReset = async (e) => {
    console.log("Function Trigger");
    e.preventDefault();
    try {
      const activeObject = canvas.getActiveObject();

      const data2 = {
        session_id: activeObject.session_id,
      };

      const response = await axios.post(apiUrl1, data2, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      const originalImagePath =
        "http://127.0.0.1:5000/" + response.data.originalImagePath;
      const originalPalette = response.data.paletteColors;
      console.log("originalImagePath",originalImagePath);

      const isEqualToExcludedColor1 = (color) => {
        return color[0] === 254 && color[1] === 254 && color[2] === 218;
      };

      const filteredPaletteColors1 = originalPalette.filter(
        (color) => !isEqualToExcludedColor1(color)
      );

      const originalPaletteString = JSON.stringify(filteredPaletteColors1);

      const base = await loadImageToBase64(originalImagePath);
      const object = canvas.getActiveObject();

      if (object && object.type === "image") {
        fabric.util.loadImage(base, function (imgs) {
          let img2 = new fabric.Image(imgs, {
            src: originalImagePath,
            top: object.top,
            flipX: object.flipX,
            flipY: object.flipY,
            img: true,
            width: object.width,
            height: object.height,
            width2: object.width2,
            height2: object.height2,
            left: object.left,
            zoomX: object.zoomX,
            zoomY: object.zoomY,
            filters: object.filters,
            paletteColors: filteredPaletteColors1,
            dominant_color: object.dominant_color,
            bgRemove: object.bgRemove,
            makeOneColorCode: object.makeOneColorCode,
            makeSingleColor: object.makeSingleColor,
            makeSingleColorInvert: object.makeSingleColorInvert,
            makeOneColor: object.makeOneColor,
            angle: object.angle,
            session_id: object.session_id,
            scaleX: object.scaleX,
            scaleY: object.scaleY,
            lock: object.lock,
            cropX: object.cropX,
            cropY: object.cropY,
            quantized_image: object.quantized_image,
            imageFile:object.imageFile,
            imageType:object.imageType,
            newImagePath: originalImagePath,
            type: "image",
            designElement:"true",
            singleColor: object.singleColor,
            extractedColorVal: object.extractedColorVal,
            selectedColorIndex: object.selectedColorIndex,
            size: object.size,
            cache: true,
            imageSmoothingEnabled: true,
            imageSmoothingQuality: "high",
            closePropertiesSidebar,

          });

          canvas.remove(object);
          canvas.add(img2);
          canvas.setActiveObject(img2);
          canvas.renderAll();

          img2.on("loaded", function () {
            img2.getElement().toBlob((blob) => {
              const blobUrl = URL.createObjectURL(blob);
              console.log("Blob URL:", blobUrl);
            });
          });
        });

        // Update the palette colors after resetting
        setPaletteColors(filteredPaletteColors1);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const loadImageToBase64 = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const base64 = canvas.toDataURL("image/png");
        resolve(base64);
      };
      img.onerror = function (error) {
        reject(error);
      };
      img.src = url;
    });
  };
console.log(activeObject.imageFile);
console.log("paletteColors",paletteColors)

const tabs = [
  {

    
    label: (
      <div className="tab-label">
        <img src={colorclip} alt="Edit Text Icon" />
        <br />
       Color
      </div>
    ),
    content: (
      <div>
        <div className="inner">
          <label style={{ color: "black", fontSize: "12px" }}  className="labFont">Colors</label>
          {!singleColorMode && !makeColorMode && (
            <div>
            {activeObject.paletteColors === null || activeObject.paletteColors?.length === 0 ? (

                <span
                  style={{ color: "black", fontSize: "12px", marginLeft: "10px" }}
                >
                  Full Color
                </span>
              ) : (
                <ImagePaletteComponent
                  initialPaletteColors={activeObject.paletteColors}
                  canvas={canvas}
                  setSingleColor={setSingleColor}
                  setIsPng={setIsPng}
                  dominantColors={dominantColor}
                  addToHistory={addToHistory}
                  saveCanvasDataToLocalStorage={saveCanvasDataToLocalStorage}
                  activeTab={activeTab}
                  setShowImagePalette={setShowImagePalette}
                  calculatePrice={calculatePrice}
                  removeBackground={removeBackground}
                  handleColorReset={(e) => handleColorReset(e)}

                />
              )}
            </div>
          )}

          {singleColorMode && (
            <>
            <div className="outline-main">
              <div className=""
                style={{
                  width: "25px",
                  height: "25px",
                  backgroundColor: `rgb(${singleColor.r}, ${singleColor.g}, ${singleColor.b})`,
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={() => setShowColorPicker(!showColorPicker)}
              ></div></div>
              {showColorPicker && (
                <div style={{ position: "", zIndex: "2" }}>
                  <div
                    style={{
                      position: "",
                      top: "0px",
                      right: "0px",
                      bottom: "0px",
                      left: "0px",
                    }}
                    onClick={() => setShowColorPicker(false)}
                  />
                  <ImagePaletteBox
                    onColorChange={handleChange}
                    onClose={() => setShowColorPicker(false)}
                    setSingleColor={setSingleColor}
                    handleColorReset={(e) => handleColorReset(e)}

                    
                  />

                    
                </div>
              )}
            </>
          )}

          {/* Make One Color Picker */}
          {makeColorMode && (
            <>
                        <div className="outline-main">

              <div
                style={{
                  width: "25px",
                  height: "25px",
                  backgroundColor: `rgb(${makeColor.r}, ${makeColor.g}, ${makeColor.b})`,
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={() => setColorPicker(!colorPicker)}
              ></div>
              </div>
              {colorPicker && (
                <div style={{ position: "", zIndex: "2" }}>
                  <div
                    style={{
                      position: "",
                      top: "0px",
                      right: "0px",
                      bottom: "0px",
                      left: "0px",
                    }}
                    onClick={() => setColorPicker(false)}
                  />
                  <ImagePaletteBox
                    onColorChange={colorChange}
                    onClose={() => setColorPicker(false)}
                    setSingleColor={setMakeColor}
                    handleColorReset={(e) => handleColorReset(e)}

                  />
                </div>
              )}
            </>
          )}
        </div>
        {!singleColorMode && (
        <div className="inner">
          <label style={{ color: "black", fontSize: "12px" }} className="labFont">Single Color</label>
          <Switch checked={singleColorMode} onChange={applySingleColor} />
        </div>
        )}
        {!makeColorMode && (
        <div className="inner">
          <label style={{ color: "black", fontSize: "12px" }} className="labFont">Make One Color</label>
          <Switch checked={makeColorMode} onChange={applyMakeColor} />
        </div>
        )}
      </div>
    ),
  },
  {
    label: (
      <div className="tab-label">
        <img src={transformclip} alt="Edit Text Icon" />
        <br />
       Transform
      </div>
    ),
    content: (
      <div>
         <div className="icon-row">
                      <button title="Center Object" onClick={handleCenterObject}        className={isCentered ? "selected" : ""}
>
                      <img src={objectcenter} alt="bringtofront" className="top-icon"/>
                      </button>
                      <button title="Bring to Front" onClick={handleBringToFront}  className={isSelected ? "selected" : ""}>
                      <img src={bringtofront} alt="bringtofront" className="top-icon"/>
                  
                      </button>
                      <button title="Flip Horizontal" onClick={handleFlipHorizontal}  className={isFlippedHorizontal ? "selected" : ""}>
                      <img src={mirrorhorizontal} alt="bringtofront" className="top-icon"/>

                
                      </button>
                      <button title="Flip Vertical" onClick={handleFlipVertical}        className={isFlippedVertical ? "selected" : ""}
>
                      <img src={mirrorvertical} alt="bringtofront" className="top-icon"/>

               
                      </button>
                      <button title="Lock/Unlock Object" onClick={handleToggleLock}>
  {isLocked ? (
    <img src={lock} alt="Locked" className="top-icon" />
  ) : (
    <img src={unlock} alt="Unlocked" className="top-icon" />
  )}
</button>

                    </div>
      </div>
    ),
  },
  {
    label: (
      <div className="tab-label">
        <img src={rotationmobtext} alt="Edit Text Icon" />
        <br />
       Rotation
      </div>
    ),
    content: (
      <div className="inner">
        <label style={{ color: "black", fontSize: "12px" }} className="labFont">Rotation</label>
        <input
          type="range" className="range-bar"
          min="0"
          max="360"
          value={rotation}
          onChange={(e) => handleRotationChange(e.target.value)}
        />
        <span>{rotation}°</span>
      </div>
    ),
  },

  activeObject?.imageFile && {
    label: (
      <div className="tab-label">
        <img src={backgroundColor} alt="Edit Text Icon" />
        <br />
        Background
      </div>
    ),
    content: (
      <div className="inner">
        <label style={{ color: "black", fontSize: "12px" }} className="labFont">
          Remove Background
        </label>
        <Switch checked={removeBackground} onChange={handleSwitchChange} />
      </div>
    ),
  },

];

const handleTabChange = (index) => {
  setActiveTabIndex(index);
};


return (
  <><div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "3px",
    backgroundColor: "#f6f6f6",
  }}
>
  <h5
    style={{
      margin: "0 auto",
      color: "#aaaa",
      fontWeight: "400",
      textAlign: "center",
      flexGrow: 1,
    }}
  >
   Edit image 
  </h5>
  <button
    onClick={closePropertiesSidebar}
    style={{
      backgroundColor: "transparent",
      border: "none",
      cursor: "pointer",
      fontSize: "18px",
      fontWeight: "bold",
      marginLeft: "auto",
    }}
    aria-label="Close"
  >
<img src={close} alt="Close" className="closeicon"/>
  </button>
</div>
  <div className="detail-text-box">
    {isMobileScreen ? (
      // For mobile screens, display a tabbed layout
      <div className="mobile-tabs-container"> 
        {/* Tab List */}
        {/* <ul className="tab-list">
          {tabs.map((tab, index) => (
            <li
              key={index}
              className={activeTabIndex === index ? "active" : ""}
              onClick={() => handleTabChange(index)}
            >
              {tab.label}
            </li>
          ))}
        </ul> */}

        {/* Active Tab Content */}
        {activeTabIndex !== null ? (
          <div className="tab-content">
            {tabs[activeTabIndex].content}
            {/* Display color box for Single Color Mode */}
            {/* {activeTabIndex === 0 && singleColorMode && (
              <>
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: `rgb(${singleColor.r}, ${singleColor.g}, ${singleColor.b})`,
                    border: "1px solid #000",
                    cursor: "pointer",
                    marginTop: "10px",
                  }}
                  onClick={() => setShowColorPicker(!showColorPicker)}
                ></div>
                {showColorPicker && (
                  <div style={{ position: "absolute", zIndex: "2" }}>
                    <div
                      style={{
                        position: "fixed",
                        top: "0px",
                        right: "0px",
                        bottom: "0px",
                        left: "0px",
                      }}
                      onClick={() => setShowColorPicker(false)}
                    />
                    <ImagePaletteBox
                      onColorChange={handleChange}
                      onClose={() => setShowColorPicker(false)}
                      setSingleColor={setSingleColor}
                    />
                  </div>
                )}
              </>
            )} */}
            {/* Display color box for Make One Color Mode */}
            {/* {activeTabIndex === 0 && makeColorMode && (
              <>
                <div
                  style={{
                    width: "20px",
                    height: "20px",
                    backgroundColor: `rgb(${makeColor.r}, ${makeColor.g}, ${makeColor.b})`,
                    border: "1px solid #000",
                    cursor: "pointer",
                    marginTop: "10px",
                  }}
                  onClick={() => setColorPicker(!colorPicker)}
                ></div>
                {colorPicker && (
                  <div style={{ position: "absolute", zIndex: "2" }}>
                    <div
                      style={{
                        position: "fixed",
                        top: "0px",
                        right: "0px",
                        bottom: "0px",
                        left: "0px",
                      }}
                      onClick={() => setColorPicker(false)}
                    />
                    <ImagePaletteBox
                      onColorChange={colorChange}
                      onClose={() => setColorPicker(false)}
                      setSingleColor={setMakeColor}
                    />
                  </div>
                )}
              </>
            )} */}
          </div>
        ) : (
          <div className="tab-placeholder"></div>
        )}
         <ul className="tab-list">
          {tabs.map((tab, index) => (
            <li
              key={index}
              className={activeTabIndex === index ? "active" : ""}
              onClick={() => handleTabChange(index)}
            >
              {tab.label}
            </li>
          ))}
        </ul>
      </div>
    ) : (
      // For larger screens, display all content without tabs
      <>
        {/* Transform Controls */}
        <div className="icon-row">
                      <button title="Center Object" onClick={handleCenterObject}        className={isCentered ? "selected" : ""}
>
                      <img src={objectcenter} alt="bringtofront" className="top-icon"/>
                      </button>
                      <button title="Bring to Front" onClick={handleBringToFront}  className={isSelected ? "selected" : ""}>
                      <img src={bringtofront} alt="bringtofront" className="top-icon"/>
                  
                      </button>
                      <button title="Flip Horizontal" onClick={handleFlipHorizontal}  className={isFlippedHorizontal ? "selected" : ""}>
                      <img src={mirrorhorizontal} alt="bringtofront" className="top-icon"/>

                
                      </button>
                      <button title="Flip Vertical" onClick={handleFlipVertical}        className={isFlippedVertical ? "selected" : ""}
>
                      <img src={mirrorvertical} alt="bringtofront" className="top-icon"/>

               
                      </button>
                      <button title="Lock/Unlock Object" onClick={handleToggleLock}>
  {isLocked ? (
    <img src={lock} alt="Locked" className="top-icon" />
  ) : (
    <img src={unlock} alt="Unlocked" className="top-icon" />
  )}
</button>

                    </div>

        {/* Rotation Control */}
        <div className="inner">
          <label style={{ color: "black", fontSize: "12px" }} className="labFont">Rotation</label>
          <input className="range-bar"
            type="range"
            min="0"
            max="360"
            value={rotation}
            onChange={(e) => handleRotationChange(e.target.value)}
          />
          <span>{rotation}°</span>
        </div>

        {/* Colors (when not in Single Color or Make One Color modes) */}
        <div className="inner" style={{ display: "flex", alignItems: "center" }}>
          <label style={{ color: "black", fontSize: "12px" }} className="labFont">Color</label>
          {!singleColorMode && !makeColorMode && (
            <div>
  {activeObject.paletteColors === null || activeObject.paletteColors?.length === 0 ? (                <span
                  style={{ color: "black", fontSize: "12px", marginLeft: "10px" }}
                >
                  Full Color
                </span>
              ) : (
                <ImagePaletteComponent
                  initialPaletteColors={activeObject.paletteColors}
                  canvas={canvas}
                  setSingleColor={setSingleColor}
                  setIsPng={setIsPng}
                  dominantColors={dominantColor}
                  addToHistory={addToHistory}
                  saveCanvasDataToLocalStorage={saveCanvasDataToLocalStorage}
                  activeTab={activeTab}
                  setShowImagePalette={setShowImagePalette}
                  calculatePrice={calculatePrice}
                  removeBackground={removeBackground}
                  handleColorReset={(e) => handleColorReset(e)}
               

                />
              )}
            </div>
          )}

          {/* Single Color Picker */}
          {singleColorMode && (
            <>
                        <div className="outline-main">

              <div
                style={{
                  width: "25px",
                  height: "25px",
                  backgroundColor: `rgb(${singleColor.r}, ${singleColor.g}, ${singleColor.b})`,
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={() => setShowColorPicker(!showColorPicker)}
              ></div>
              </div>
              {showColorPicker && (
                <div style={{ position: "", zIndex: "2" }}>
                  <div
                    style={{
                      position: "",
                      top: "0px",
                      right: "0px",
                      bottom: "0px",
                      left: "0px",
                    }}
                    onClick={() => setShowColorPicker(false)}
                  />
                  <ImagePaletteBox
                    onColorChange={handleChange}
                    onClose={() => setShowColorPicker(false)}
                    setSingleColor={setSingleColor}
                    handleColorReset={(e) => handleColorReset(e)}
                      excludeNoFill={true} // ✅ add this line


                  />
                </div>
              )}
            </>
          )}

          {/* Make One Color Picker */}
          {makeColorMode && (
            <>
                        <div className="outline-main">

              <div
                style={{
                  width: "25px",
                  height: "25px",
                  backgroundColor: `rgb(${makeColor.r}, ${makeColor.g}, ${makeColor.b})`,
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
                onClick={() => setColorPicker(!colorPicker)}
              ></div>
              </div>
              {colorPicker && (
                <div style={{ position: "", zIndex: "2" }}>
                  <div
                    style={{
                      position: "",
                      top: "0px",
                      right: "0px",
                      bottom: "0px",
                      left: "0px",
                    }}
                    onClick={() => setColorPicker(false)}
                  />
                  <ImagePaletteBox
                    onColorChange={colorChange}
                    onClose={() => setColorPicker(false)}
                    setSingleColor={setMakeColor}
                    handleColorReset={(e) => handleColorReset(e)}
                      excludeNoFill={true} // ✅ add this line



                  />
                </div>
              )}
            </>
          )}
        </div>

        {/* Single Color Switch */}
        {!makeColorMode && (
          <div className="inner">
            <label style={{ color: "black", fontSize: "12px" }} className="labFont">Single Color</label>
            <Switch checked={singleColorMode} onChange={applySingleColor} />
          </div>
        )}

        {/* Make One Color Switch */}
        {!singleColorMode && (
          <div className="inner">
            <label style={{ color: "black", fontSize: "12px" }} className="labFont">Make One Color</label>
            <Switch checked={makeColorMode} onChange={applyMakeColor} />
          </div>
        )}

        {/* Remove Background Switch */}
        {activeObject?.imageFile && (
          <div className="inner">
            <label style={{ color: "black", fontSize: "12px" }} className="labFont">Remove Background</label>
            <Switch checked={removeBackground} onChange={handleSwitchChange} />
          </div>
        )}

        {/* Auto Resize Display */}
      
        <div className="inner">
      <label style={{ color: "black", fontSize: "12px" }} className="labFont">Auto Resize</label>
      <span style={{ color: "black", fontSize: "10px" }}className="labFont"><span className="inches">{imgwidth}</span>in</span>{" "}
      <span style={{ color: "black", fontSize: "10px" }}className="labFont">x</span>{" "}
      <span style={{ color: "black", fontSize: "10px" }}className="labFont"><span className="inches">{imgheight}</span>in</span>
    </div>
      </>
    )}
  </div>
  </>
);




}

